module.exports = __webpack_public_path__ + "img/PASTE.d9cab5fd.svg";